import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
// Using "setup" style store, see: https://pinia.vuejs.org/core-concepts/#Setup-Stores
export const useMiniPlayer = defineStore('miniPlayer', () => {
    // refs = state
    const currentTrackId = ref(null);
    const isPlaying = ref(false);
    const hasErrored = ref(false);
    const progress = ref(0);
    const playInBackground = ref(true);
    const prefetchTrackId = ref(null);
    const isPrefetch = ref(false);

    // actions = mutations
    function playTrack(payload) {
        // console.log('MINIPLAYER STORE | playTrack', payload);
        currentTrackId.value = payload;
        hasErrored.value = false;
        isPlaying.value = true;
        progress.value = 0;
        isPrefetch.value = false;
    }
    function preloadTrack(trackId) {
        prefetchTrackId.value = trackId;
    }
    function updateCurrentTrack(payload) {
        // console.log('MINIPLAYER STORE | updateCurrentTrack', payload);
        currentTrackId.value = payload;
        if (!payload) {
            isPlaying.value = false;
        }
    }
    function updateIsPlaying(status) {
        // console.log('MINIPLAYER STORE | updateIsPlaying', status);
        isPlaying.value = status;
    }
    function updateProgress(newProgress) {
        progress.value = newProgress;
    }
    function updatePlayingInBackground(pibStatus) {
        playInBackground.value = pibStatus;
    }
    function togglePlayingInBackground() {
        playInBackground.value = !playInBackground.value;
    }
    function setErrorState(errorState) {
        hasErrored.value = errorState;
    }
    function updatePlayingStatus (status) {
        updateIsPlaying(status);
    }
    function clearCurrentTrack() {
        updateCurrentTrack(null);
    }

    return { 
        currentTrackId,
        isPlaying,
        hasErrored,
        progress,
        playInBackground,
        prefetchTrackId,
        playTrack,
        preloadTrack,
        updateCurrentTrack,
        updateIsPlaying,
        updateProgress,
        updatePlayingInBackground,
        togglePlayingInBackground,
        setErrorState,
        updatePlayingStatus,
        clearCurrentTrack,
     }
})